module.exports = __webpack_public_path__ + "img/start-counting-disabled.d21e2f61.svg";